(function(angular) {
  var ModelListController = function(
      $scope, $location, $timeout, $localStorage, $sessionStorage, $http,
      $window, likes) {
    var self = this;

    var retrieveGender = function() {
      var path = $location.path();
      return ~path.indexOf('female') ? 'F' : (~path.indexOf('male')
          ? 'M'
          : null);
    };

    var firstLoad = false;

    self.gender = retrieveGender();

    self.storage = $localStorage.$supported() ? $localStorage : $sessionStorage;
    self.filters = {
      gender: self.gender,
      olderThen30: false,
      classic: false,
      newcomer: false,
    };
    self.initParams = {};
    self.params = {
      loader: false,
      hasMoreData: false,
    };
    self.data = [];
    self.likes = likes;

    self.init = function(dataUrl, limit, offset) {
      self.initParams['dataUrl'] = dataUrl;
      self.initParams['limit'] = limit;
      self.initParams['offset'] = offset;

      var storedFilters;
      if (self.storage.filters &&
          (storedFilters = self.storage.filters[self.gender])) {
        self.filters = storedFilters;
      }

      self.params = angular.copy(self.initParams);

      self.loadData(true);
      likes.load();
    };

    self.loadData = function(reset) {
      if (reset === true) {
        angular.extend(self.params, angular.copy(self.initParams));
      }
      self.params.loader = true;
      var dto = buildDtoObject();
      $http.post(self.params['dataUrl'], dto, {}).
          then(function(response) {

            if (reset === true) {
              self.data = [];
            }

            self.data = self.data.concat(response.data.data);
            angular.extend(self.params, response.data.params);
            $timeout(function() {
              self.params.loader = false;
              self.params.hasMoreData = self.params.count > self.data.length;

              storeResult();

            });
          }, function(response) {
            self.data = [];
            self.params.loader = false;
          });
    };

    self.openPageAnimation = function(event) {
      event.preventDefault();
      var target = event.target,
          href = target.href;

      angular.element('body').addClass('menu-open');
      angular.element('body > .loading').removeClass('loading--hide');

      $timeout(function() {
        //As an HTTP redirect (back button will not work )
        window.location.replace(href);
        //like if you click on a link (it will be saved in the session history,
        //so the back button will work as expected)
        window.location.href = href;
      }, (400));
    };

    $scope.$watchCollection('list.filters', function(newValues, oldValues) {
      if (!angular.equals(newValues, oldValues)) {
        $timeout(function() {
          if (!self.storage.filters) {
            self.storage.filters = {};
          }

          if (!self.storage.filters[self.gender]) {
            self.storage.filters[self.gender] = {};
          }

          self.storage.filters[self.gender] = self.filters;
          self.loadData(true);
        });
      }

    });

    var storeResult = function() {
      // var hashParts = {
      //   filters: self.filters
      // }
    };

    var buildDtoObject = function() {
      var dto = {
        demand: angular.copy(self.filters),
      };
      angular.extend(dto['demand'], {
        limit: self.params.limit,
        offset: self.params.offset,
      });
      return dto;
    };

  };

  angular.module('ins.models').
      controller('ModelListController', ModelListController);
})(window.angular);